__turbopack_context__.v({
  "background": "LV3idW_background",
  "button": "LV3idW_button",
  "card": "LV3idW_card",
  "card--placeholder": "LV3idW_card--placeholder",
  "content": "LV3idW_content",
  "content__info": "LV3idW_content__info",
  "content__text": "LV3idW_content__text",
  "description": "LV3idW_description",
  "shimmer": "LV3idW_shimmer",
  "text-bar-sweep": "LV3idW_text-bar-sweep",
  "title": "LV3idW_title",
});
